/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { CodeShareSearch } from "types";
import { SandboxResult, SearchResponse } from "./SearchClient";

export class SearchSerializer {
  public static async deserialize(searchResults: SearchResponse<SandboxResult>) {
    const metadata: CodeShareSearch[] = [];

    for await (const result of searchResults.hits) {
      const [userId, id] = result.objectID.split("+");
      metadata.push({
        id,
        userId,
        name: result.name,
        description: result.description,
        username: result.username,
        isThumbnailAdded: true,
      });
    }
    return metadata;
  }
}
